// GENERATED by scripts/build-icons.mjs from icons/library.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Library = createIcon('library', [
  ['path', { d: "m16 6 4 14" }],
  ['path', { d: "M12 6v14" }],
  ['path', { d: "M8 8v12" }],
  ['path', { d: "M4 4v16" }],
])
